export default "__VITE_ASSET__BF804Baq__"